<template>
    <div>
        <div>
            <b-form @submit="onSubmit"
                @reset="onReset"
                v-if="show">
                <b-form-input type="email"
                    :placeholder="$t('users.email')"
                    id="inputEmail"
                    required
                    class="my-5 inputField"
                    v-model="form.email"></b-form-input>
                <b-form-input type="password"
                    :placeholder="$t('users.password')"
                    id="inputPassword"
                    required
                    class="my-5 inputField"
                    v-model="form.password"></b-form-input>
                <b-button pill
                    class="formButton"
                    type="submit">
                    {{ $t('actions.login') }}
                </b-button>
            </b-form>
        </div>
        <div class="my-3">
            <div @click="$router.push('/forgot')"
                class="lostPassword">
                {{ $t('users.lost-password') }}
            </div>
        </div>
        <b-alert v-model="errored"
            variant="danger"
            dismissible>
            {{ errorMsg }}
        </b-alert>
    </div>
</template>

<script>
export default {
    name: 'Loginform',
    data () {
        return {
            form: {
                email: '',
                password: ''
            },
            show: true,
            errorMsg: '',
            errored: false
        }
    },
    methods: {
        loginSuccessful (req) {
            if (!req.data.token) {
                this.loginFailed()
                return
            }

            localStorage.token = req.data.token
            this.error = false

            this.$router.push('/dashboard')
        },
        loginFailed () {
            this.errorMsg = this.$t('validations.login-fail')
            delete localStorage.token
        },
        onSubmit (evt) {
            evt.preventDefault()
            let self = this
            let data = {
                email: this.form.email,
                password: this.form.password
            }
            this.$store.dispatch('login', data)
                .then(() => { this.$router.push('/dashboard') })
                .catch(() => {
                    self.loginFailed()
                    self.errored = true
                })
        },
        onReset (evt) {
            evt.preventDefault()
            // Reset our form values
            this.form.email = ''
            this.form.password = ''
            // Trick to reset/clear native browser form validation state
            this.show = false
            this.$nextTick(() => {
                this.show = true
            })
        }
    }
}
</script>
